import { render, staticRenderFns } from "./CardOptions.vue?vue&type=template&id=5fda71ee&scoped=true&"
import script from "./CardOptions.vue?vue&type=script&lang=js&"
export * from "./CardOptions.vue?vue&type=script&lang=js&"
import style0 from "./CardOptions.vue?vue&type=style&index=0&id=5fda71ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fda71ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListItem } from 'vuetify/lib'
import { VListItemTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
installComponents(component, {VBtn,VList,VListItem,VListItemTitle,VMenu})
